import ReactGTM from "react-gtm-module";
export const GoogleTagManager = () => {
  ReactGTM.initialize({ gtmId: "GTM-F9GQ" });
  return <></>;
};
